import { createContext } from "react";

const searchContext = createContext();

export default searchContext;
